import React from 'react';

export const ShouldRender = ({ children, condition }) => (
    condition ? <>{children}</> : null
);
